import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { gray, green } from '@kizen/kds/Colors';

const Wrapper = styled.div`
  ${({ width }) =>
    width &&
    css`
      width: ${width}px;
    `}
  display: flex;
  flex: 1;
`;

const Bar = styled.div`
  ${({ width, height, color, radius }) =>
    width &&
    css`
      width: ${width}px;
      height: ${height}px;
      background-color: ${color};
      border-radius: ${radius / 2}px;
    `}
`;

const calcBarWidth = (width, radius, percentage) => {
  const w = parseInt(width, 10);
  const r = parseInt(radius, 10);
  const p = Math.max(0, Math.min(100, parseInt(percentage, 10)));
  return ((w - r) * p) / 100 + r;
};

const PercentageBar = ({
  percentage,
  width = 100,
  radius = 10,
  primaryColor = green['green-700'],
  backgroundColor = gray['gray-400'],
}) => {
  const barWidth = calcBarWidth(width, radius, percentage);
  return (
    <Wrapper width={width}>
      <Bar
        width={width}
        height={radius}
        color={backgroundColor}
        radius={radius}
      >
        <Bar
          width={barWidth}
          height={radius}
          color={primaryColor}
          radius={radius}
        />
      </Bar>
    </Wrapper>
  );
};

export default PercentageBar;
